import { render, staticRenderFns } from "./DynamicField.vue?vue&type=template&id=0a667d2c&scoped=true&"
import script from "./DynamicField.vue?vue&type=script&lang=js&"
export * from "./DynamicField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicField.vue?vue&type=style&index=0&id=0a667d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a667d2c",
  null
  
)

export default component.exports